import { render, staticRenderFns } from "./BordaEMassa.vue?vue&type=template&id=5342e283&scoped=true&"
import script from "./BordaEMassa.vue?vue&type=script&lang=js&"
export * from "./BordaEMassa.vue?vue&type=script&lang=js&"
import style0 from "./BordaEMassa.vue?vue&type=style&index=0&id=5342e283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342e283",
  null
  
)

export default component.exports